<template>
  <div class="content">
    <div>
      <div class="md-layout-item md-size-100 text-right">
        <md-button class="md-raised md-success mr-4" @click="blogModal('new', {})">New Tag</md-button>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Tags</h4>
          </md-card-header>
          <md-card-content>
            <div class="tags_container">
              <md-chip
                  v-for="(tag, index) in tags"
                  :key="index"
                  class="skill-chip"
                  md-deletable
                  @md-delete="removeTag(tag)"
              >
                <span @click="blogModal('edit', tag)">{{ tag.name }}</span>
              </md-chip>
            </div>
          </md-card-content>
        </md-card>
      </div>

    </div>

    <!-- add dialog-->
    <md-dialog :md-active.sync="showDialog" class="custom-dialog md-size-100">
      <md-dialog-title>{{modalText.title}} Tag</md-dialog-title>

      <div class="md-layout-item md-small-size-100 md-size-100 px-4">
        <md-field class="mb-1" :class="{ 'md-invalid': modalErrors && modalErrors.name }">
          <label>Tag</label>
          <md-input
              v-model="modalData.name"
              type="text"
              required
              md-placeholder="Tag name"
          ></md-input>
          <span class="md-error" v-if="modalErrors && modalErrors.name">
            {{ modalErrors.name[0] }}
          </span>
        </md-field>
      </div>
      <div class="md-layout-item md-small-size-100 md-size-100 px-4">
      </div>
      <md-dialog-actions class="m-3">
        <md-button class="md-secondary" @click="showDialog = false">Close</md-button>
        <md-button class="md-success" @click="onConfirm()" >{{modalText.btnText}} Tag</md-button>
      </md-dialog-actions>
    </md-dialog>
    <!-- add dialog-->

    <!-- delete dialog-->
    <md-dialog :md-active.sync="showDelDialog" class="custom-dialog md-size-100">
      <md-dialog-title>Delete Tag</md-dialog-title>

      <div class="md-layout-item md-small-size-100 md-size-100 px-4">
        <h4>Are you sure you want to delete this tag?</h4>
        <br>
        <p>This action cannot be undone and the tag details will be permanently removed.</p>
      </div>
      <div class="md-layout-item md-small-size-100 md-size-100 px-4">
      </div>
      <md-dialog-actions class="m-3">
        <md-button class="md-secondary" @click="showDelDialog = false">Close</md-button>
        <md-button class="md-success" @click="onConfirmDel()" >Delete Tag</md-button>
      </md-dialog-actions>
    </md-dialog>
    <!-- delete dialog-->

  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "AdminTags",
  data() {
    return {
      showDialog: false,
      showDelDialog: false,
      modalText: {
        title: 'New',
        btnText: 'Add'
      },
      modalData: {
        id: '',
        name: '',
        mode: ''
      },
      modalErrors: {},
      tags: []
    }
  },
  created() {
    this.getAllTags()
  },
  methods: {
    ...mapActions(["createEditTag", "getAdminTags", "deleteAdminTag"]),
    blogModal(mode, item) {
      this.showDialog = true
      this.modalErrors = {}
      if(mode == 'new' ) {
        this.modalData.id = ''
        this.modalData.name = ''
        this.modalData.mode = 'new'
        this.modalText.title = 'New'
        this.modalText.btnText = 'Create'
      } else {
        this.modalText.title = 'Edit'
        this.modalText.btnText = 'Edit'
        this.modalData.mode = 'edit'
        this.modalData.id = item.id
        this.modalData.name = item.name
      }
    },
    onConfirm() {
      this.modalErrors = {};

      // Trim name and normalize case
      const newName = (this.modalData.name || '').trim();

      if (!newName) {
        this.modalErrors = { name: ['Tag name is required'] };
        return;
      }

      // Common duplicate check for both "new" and "edit"
      const exists = this.tags.some(tag => {
        // ignore the same tag when editing
        if (this.modalData.mode === 'edit' && tag.id === this.modalData.id) {
          return false;
        }
        return tag.name.trim().toLowerCase() === newName.toLowerCase();
      });

      if (exists) {
        this.modalErrors = { name: ['Tag with this name already exists'] };
        return;
      }

      // use normalized value
      this.modalData.name = newName;

      this.createEditTag(this.modalData)
          .then(res => {
            if (res.status == 422) {
              this.modalErrors = res.response.data.errors;
            } else {
              this.showDialog = false;
              this.getAllTags();
            }
          });
    },
    removeTag(tag) {
      this.modalData.id = tag.id
      this.modalData.name = tag.name
      this.showDelDialog = true
    },
    onConfirmDel() {
      this.deleteAdminTag(this.modalData.id)
      .then(res => {
        if(res.status == 200 || res.status == 201) {
          this.showDelDialog = false
          this.getAllTags()
        }
      })

    },
    getAllTags() {
      this.getAdminTags()
      .then(res => {
        this.tags = res.data.data
      })
    }
  }
}
</script>

<style scoped lang="scss">
.skill-chip {
  background: #000;
  color: #fff;
  border-radius: 20px;
  padding: 4px 35px 4px 14px;
  line-height: 34px;
  font-size: 16px;
  margin: 14px;
  display: inline-table;
  & span {
    padding: 10px;
  }
}
</style>
